import { Notification } from 'lib/types/global';

import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from './actionTypes';

export type NotificationsAction =
  | AddNotificationAction
  | RemoveNotificationAction;

interface AddNotificationAction {
  type: ADD_NOTIFICATION;
  notification: Notification;
}

interface RemoveNotificationAction {
  type: REMOVE_NOTIFICATION;
  id: number;
}

export const addNotification = (
  notification: Notification,
): AddNotificationAction => ({
  type: ADD_NOTIFICATION,
  notification,
});

export const removeNotification = (id: number): RemoveNotificationAction => ({
  type: REMOVE_NOTIFICATION,
  id,
});
